// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"wrapper___iK42g","logo":"logo___0aIfi","wrapperModal":"wrapperModal___Tgc4p"};